import React, { useState } from "react";
import { createPortal } from "react-dom";
import { CheckCircle2, CalendarClock } from "lucide-react";

const Shell = ({ children, testid }) => createPortal(
  <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid={testid}>
    <div className="w-full max-w-md bg-white rounded-3xl p-5 space-y-4 shadow-xl">{children}</div>
  </div>, document.body);

const REASONS = ["Parts needed", "Weather", "No access", "Ran out of time", "Client not home"];
const tomorrow = (d) => { const x = new Date(`${d}T12:00:00`); x.setDate(x.getDate() + 1); return x.toISOString().slice(0, 10); };

// Set Runback: the tech picks the day he'll come back
export function RunbackPicker({ date, busy, onPick, onCancel }) {
  const [d, setD] = useState(""), [why, setWhy] = useState("");
  return (
    <Shell testid="tech-runback-popup">
      <CalendarClock className="h-12 w-12 text-amber-500 mx-auto" />
      <div className="text-[20px] font-black text-center text-[#0f2f52]">When will you come back?</div>
      <input type="date" value={d} min={tomorrow(date)} onChange={(e) => setD(e.target.value)} data-testid="tech-runback-date"
        className="w-full h-14 rounded-2xl border-2 border-slate-300 px-4 text-[19px] font-bold" />
      <div className="text-[16px] font-black text-slate-700">Why couldn't you finish? <span className="font-medium text-slate-400">(optional)</span></div>
      <div className="flex flex-wrap gap-2">
        {REASONS.map((r) => <button key={r} onClick={() => setWhy(r)} data-testid={`tech-runback-reason-${r.split(" ")[0].toLowerCase()}`}
          className={`h-10 px-3 rounded-full text-[15px] font-bold border-2 ${why === r ? "bg-amber-400 border-amber-500 text-[#0f2f52]" : "bg-white border-slate-300 text-slate-700"}`}>{r}</button>)}
      </div>
      <input value={why} onChange={(e) => setWhy(e.target.value.slice(0, 120))} placeholder="Or type your own reason" data-testid="tech-runback-reason"
        className="w-full h-12 rounded-2xl border-2 border-slate-300 px-4 text-[17px]" />
      <div className="grid grid-cols-2 gap-3">
        <button onClick={onCancel} data-testid="tech-runback-cancel" className="h-14 rounded-2xl bg-slate-200 text-slate-800 text-[18px] font-black">Cancel</button>
        <button onClick={() => d && onPick(d, why.trim())} disabled={!d || busy} data-testid="tech-runback-save" className="h-14 rounded-2xl bg-amber-400 text-[#0f2f52] text-[18px] font-black disabled:opacity-50">{busy ? "Saving…" : "Set Runback"}</button>
      </div>
    </Shell>
  );
}

export function Notice({ lines, onOk }) {
  return (
    <Shell testid="tech-close-popup">
      <CheckCircle2 className="h-14 w-14 text-green-600 mx-auto" />
      <div className="text-[18px] leading-snug text-slate-800 space-y-2" data-testid="tech-close-msg">{lines.filter(Boolean).map((l) => <p key={l}>{l}</p>)}</div>
      <button onClick={onOk} data-testid="tech-close-ok" className="w-full h-14 rounded-2xl bg-[#0f2f52] text-white text-[19px] font-black">OK</button>
    </Shell>
  );
}
